import Link from 'next/link';
import PropTypes from 'prop-types';

export default function Tags({ data, active }) {
    return (
        <div className="container has-text-centered py-5">
            <div className="columns">
                <div className="column is-8 is-offset-2">
                    <div className="buttons are-small is-centered">
                        {data &&
                            data.map(tag => (
                                <Link key={tag.id} href={`/tags/${encodeURIComponent(tag.slug)}`}>
                                    <a
                                        className={`button is-info ${
                                            active && active === tag.slug ? 'is-active' : 'is-light'
                                        }`}
                                    >
                                        {tag.name}
                                    </a>
                                </Link>
                            ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

Tags.propTypes = {
    data: PropTypes.array,
    active: PropTypes.string,
};
